import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { UserRol } from "@models/user-rol";
import {RolGroup} from "@models/rol-group";

@Injectable({providedIn: 'root'})
export class RolGroupClass extends AbstractClass {
  model: RolGroup;
  modelName = 'RoleGroup';
  idName = 'roleGroupID';
  langBase = 'cms.components.rol-group.';
  route = 'admin/es/settings/rol-group';
  tableCells: TableCell[] = [
    { name: 'roleGroupName', label: 'roleGroupName', cellType: 'text', order: true, download: true },
    { name: 'description', label: 'description', cellType: 'text', order: true, download: true },
    { name: 'userRoles', label: 'userRoles', cellType: 'userRoles', order: true, download: true },
    { name: 'isActive', label: 'status', cellType: 'active-text', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    // { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false },
    { name: 'roleGroupName', label: 'roleGroupName', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'description', label: 'description', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' },
    { name: 'userRoles', label: 'userRoles', cellType: 'userRoles', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' }
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.model = {
      roleGroupID: 0,
      roleGroupName: '',
      description: '',
      isActive: true,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      userRoles: []
    };
  }
}
